import React from 'react'
import WebFrame from '~/elements/webFrame'
import './styles.css'

const WebFrame01 = (props) => {
  const { title, rawText } = props.data
  return <WebFrame className="webFrame01" title={title} iframeSrc={rawText}/>
}

export default WebFrame01
